import { EMPTY_OBJECT } from 'src/constants';

/**
 * Default return value for all the hooks in this file
 */
export const DefaultReturnType = {
  isOnboardingRequired: false,
  onboardingRedirectParams: EMPTY_OBJECT,
};
